import React, { FC, memo, useState } from 'react';
import { ProductImageViewModel } from '~/lib/data-contract';
import styles from './image-gallery.module.css';
import { clsx } from 'clsx';
import { queries } from '~/theme';
import ProductImage from '~/shared/components/product-image/product-image.component';
import { Modal } from '~/shared/components';

const ModalContent: FC<{ image?: ProductImageViewModel }> = ({ image }) => {
    const [isZoomed, setIsZoomed] = useState(false);
    return (
        <button
            className={isZoomed ? styles.modalImageWrapperZoomed : styles.modalImageWrapperNormal}
            onClick={() => setIsZoomed(!isZoomed)}
        >
            <ProductImage image={image} sizes={'100vw'} className={styles.modalImage} />
        </button>
    );
};

type Props = {
    images?: ProductImageViewModel[];
};

const ImageGallery: FC<Props> = memo((props) => {
    const { images } = props;
    const [selectedImage, setSelectedImage] = useState<ProductImageViewModel | null>(null);

    return (
        <>
            <div className={clsx(styles.root, 'custom-scrollbar-thin')}>
                {images
                    ?.filter((image) => image.url)
                    .map((image, i) => (
                        <button
                            aria-label={image?.label || ''}
                            className={clsx('cleanButton', styles.gridItem)}
                            key={`${i}-${image.url}`}
                            onClick={() => setSelectedImage(image || null)}
                        >
                            <ProductImage
                                priority={i < 2}
                                image={image}
                                sizes={`${queries.xs} 70vw, ${queries.sm} 22vw, ${queries.md} 30vw, 30vw`}
                            />
                        </button>
                    ))}
            </div>
            <Modal
                scrollLock
                isOpen={!!selectedImage}
                onClose={() => setSelectedImage(null)}
                variant="lightBox"
            >
                <ModalContent image={selectedImage ?? undefined} />
            </Modal>
        </>
    );
});

ImageGallery.displayName = 'ImageGallery';
export default ImageGallery;
